export enum ActionType {
    SET_STANDARD_PREVIEW_PARAMS = 'SET_STANDARD_PREVIEW_PARAMS',
    SET_RULES_BASED_PREVIEW_PARAMS = 'SET_RULES_BASED_PREVIEW_PARAMS',
    RESET_PREVIEW_PARAMS = 'RESET_PREVIEW_PARAMS',
    SET_PREVIEW_LOCALIZATION = 'SET_PREVIEW_LOCALIZATION',
    SET_TIMER_VALUE = 'SET_TIMER_VALUE',
    SET_DETECTED_MESSAGE_VARIABLES = 'SET_DETECTED_MESSAGE_VARIABLES',
    SET_MESSAGE_VARIABLE_VALUE = 'SET_MESSAGE_VARIABLE_VALUE',
}
